// Tells the site a tool was used — a search, a study panel, a highlight — so
// the admin's /stats can say which are worth the work. Fire and forget: the
// reader never waits on it and never learns it failed. A beacon where the
// browser has one, since it survives the page closing; a keepalive fetch where
// it does not. The server decides what to keep (nothing from the admin or a
// crawler) and what it keeps names nobody.
import { EVENT_DETAIL_MAX, type EventInput } from "@bibleunleashed/shared";

export type TrackedEvent = Omit<EventInput, "path">;

export function track(event: TrackedEvent): void {
  const body = JSON.stringify({
    ...event,
    ...(event.detail ? { detail: event.detail.trim().slice(0, EVENT_DETAIL_MAX) } : {}),
    path: window.location.pathname,
  });
  try {
    if (navigator.sendBeacon?.("/api/stats/event", new Blob([body], { type: "application/json" }))) return;
  } catch {
    // fall through to fetch
  }
  void fetch("/api/stats/event", {
    method: "POST",
    credentials: "same-origin",
    keepalive: true,
    headers: { "Content-Type": "application/json" },
    body,
  }).catch(() => undefined);
}
